import { render } from "./initials_step.vue?vue&type=template&id=30cbc945"
import script from "./initials_step.vue?vue&type=script&lang=js"
export * from "./initials_step.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/docuseal-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__